import React from 'react';
import { Typography } from '@mui/material';
import CandidateSection from './CandidateSection';
import Timeline from './Timeline';

const CandidateExperience = ({ experiences }) => (
    <CandidateSection title="Experience">
        {experiences?.length > 0 ? (
            <Timeline
                items={experiences}
                getTitle={(item) => item.title}
                getSubtitle={(item) => item.company_title || item.company || ''}
            />
        ) : (
            <Typography variant="body2" color="text.secondary">No experience listed</Typography>
        )}
    </CandidateSection>
);

export default CandidateExperience;
